// extracted by mini-css-extract-plugin
export default {"default":"main_default__Zu8na","left":"main_left__hdRus","right":"main_right__kSWOa","image":"main_image__O2aGX"};